<template>
  <div v-if="slots.label" class="mb-3 my-4 text-mirage font-niceone-bold">
    <slot name="label"/>
  </div>
  <van-cell-group v-bind="$attrs">
    <van-cell v-for="(item, index) in getCountries" :key="`link-${index}`" :title="item.name" :id="index"
              class="font-niceone-medium cursor-pointer !sm:px-6 !sm:py-3 !md:p-3"
              :class="{' border-b b' : getCountries?.length !== index + 1}" @click="setCountry(item)">
      <template #icon>
        <niceone-image :src="item.thumb" class="ltr:mr-4 rtl:ml-4" width="34"></niceone-image>
      </template>
      <template #value>
        <van-icon :name="$publicPath('/images/profile/good.svg')" v-if="countryValue === item.iso_code_2" size="16"
                  color="#64A6F1" class="mt-1"/>
      </template>
    </van-cell>
  </van-cell-group>
</template>

<script setup>
import {useCountryStore} from '~/store/countries'
import {storeToRefs} from "pinia";
import {ISO_CODES} from "@/helper";
import {useSlots} from 'vue'

const slots = useSlots()
const countryStore = useCountryStore()
const {countries} = storeToRefs(countryStore)

const props = defineProps({
  modelValue: String,
  saOnly: {
    type: Boolean,
    default: false
  }
})


const emit = defineEmits(['update:modelValue', 'close'])
const countryValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const setCountry = (item) => {
  countryValue.value = item?.iso_code_2
  emit('close', item)
}

const getCountries = computed(() => {
  let result = countries.value
  if (props.saOnly) {
    result = result.filter(item => item.iso_code_2 === ISO_CODES.SA)
  }
  return result || []
})
</script>
<style scoped>
::v-deep(.van-cell__title) {
  flex-basis: auto;
}

::v-deep(.van-search__content) {
  padding-right: 0.50rem;
}
</style>